/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CustomOption from './CustomOption/index'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaListDialogClearAction from 'DesignSystem/TysiaListDialog/TysiaListDialogClearAction/index'
import TysiaListDialogItems from 'DesignSystem/TysiaListDialog/TysiaListDialogItems/react'
import TysiaListDialogSaveAction from 'DesignSystem/TysiaListDialog/TysiaListDialogSaveAction/index'
import TysiaListDialogSearchCapture from 'DesignSystem/TysiaListDialog/TysiaListDialogSearchCapture/index'
import TysiaListDialogTitle from 'DesignSystem/TysiaListDialog/TysiaListDialogTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ProviderCount/Content/Content",
  closePopover,
  onValidateSubmit
  
}) {
let providersValueData = fromData.useDataValue({ viewPath,
context: 'providers',
})
let selectionValueData = fromData.useDataValue({ viewPath,
context: 'selection',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath,
  closePopover,
  onValidateSubmit
  
})
let onFilter = fromHelpers.useOnFilter({
  children,
  viewPath,
  closePopover,
  onValidateSubmit
  
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 data="providers"
 items={providersValueData}
 data="selection"
 selected={selectionValueData}
 onSubmit={onSubmit}
 closePopover={closePopover}
 onFilter={onFilter}
 onValidateSubmit={onValidateSubmit}
 itemKey="_id"
 width={286}
 height={336}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-3-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaListDialogTitle
  viewPath={`${viewPath}/TysiaListDialogTitle`}
 title="Select providers"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaListDialogClearAction
  viewPath={`${viewPath}/TysiaListDialogClearAction`}
/>
<TysiaListDialogSaveAction
  viewPath={`${viewPath}/TysiaListDialogSaveAction`}
 text="Apply"
/>
</div>
</div>
<TysiaListDialogSearchCapture
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogSearchCapture`}
/>
<TysiaListDialogItems
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogItems`}
 itemDataContextName="item"
>
{childProps => (
<CustomOption
{...childProps}
/>
)}
</TysiaListDialogItems>
</React.Fragment>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}